import { useRef } from 'react'
import { useDidChange } from '#src/hooks/useDidChange.ts'
import { reportWarning } from '#src/monitoring.ts'

export function useWarningReporter(
  message: string | null | undefined | false
): void {
  const isFirstRun = useRef(true)
  const didMessageChange = useDidChange(message)
  if ((isFirstRun.current || didMessageChange) && !!message) {
    reportWarning(message)
  }
  isFirstRun.current = false
}
